module.exports = __webpack_public_path__ + "img/bsud-phone-img.23354488.png";